'use client'

import TextArea from 'antd/es/input/TextArea'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputTextarea: SBDynamicFormInput = ({ ...rest }) => {
  return <TextArea {...rest} autoComplete="off" />
}

export { SBDynamicFormInputTextarea }
